import React from 'react';
import useCalculateItems from './useCalculateItems';
import type { VListProps } from './_props';
import { getStartIndexOffset, getStopIndexOffset, onScrolFn } from './_utils';

/**
 * A component that receive a list of items and render them in a virtualized way
 *
 * The component that you pass as a children will have to receive the style props to be at the right position.
 *
 * The style contains the *position absolute* and most important the *top position* to be at the right place
 *
 * The Component working as a Child should have the key
 *
 * @param containerHeight - The height of the container
 * @param containerWidth - The width of the container
 * @param totalItemsCount - The full number of items in the list
 * @param eachItemSize - The height of each item
 * @param paintedItemsAfterOverflow - The number of items that will be rendered after the visible items
 * @param children - The component that will be rendered inside a funtcion that receive the style and index {({ index, style }) => (<Component />)}
 * @returns
 */
export default function VList({
  containerHeight,
  containerWidth,
  totalItemsCount,
  eachItemSize,
  paintedItemsAfterOverflow,
  children,
}: VListProps) {
  const { setScrollTop, totalHeight, items } = useCalculateItems({
    getStartIndexOffset,
    getStopIndexOffset,
    containerHeight,
    containerWidth,
    eachItemSize,
    totalItemsCount,
    paintedItemsAfterOverflow,
    children,
  });

  return (
    <div
      style={{ height: containerHeight, width: containerWidth }}
      onScroll={(e) => onScrolFn(e, setScrollTop)}
      className="scrollbar relative overflow-auto"
    >
      <div style={{ height: totalHeight }}>{items}</div>
    </div>
  );
}
